import { render } from "./CaiDatChung.vue?vue&type=template&id=45e7d340&scoped=true"
import script from "./CaiDatChung.vue?vue&type=script&lang=js"
export * from "./CaiDatChung.vue?vue&type=script&lang=js"

import "./CaiDatChung.vue?vue&type=style&index=0&id=45e7d340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e7d340"]])

export default __exports__